// The page shell of the buyer app, built from the classes of the design system (web/tokens/components.css):
// skip link, top bar, main area, bottom bar and the live region. Every screen renders inside <main>.

import { type MouseEvent, type ReactNode } from "react";
import { useT } from "../../lib/i18n";
import { BottomNav } from "./BottomNav";
import { LiveRegionProvider } from "./LiveRegion";
import { OfflineNotice } from "./OfflineNotice";
import { TopBar } from "./TopBar";
import { UpdateNotice } from "./UpdateNotice";
import { MAIN_ID } from "./usePageTitle";

function skipToContent(event: MouseEvent<HTMLAnchorElement>): void {
  // Move focus without writing the fragment into the address and the history.
  event.preventDefault();
  document.getElementById(MAIN_ID)?.focus();
}

export function AppShell({ children }: { children: ReactNode }) {
  const t = useT();
  return (
    <LiveRegionProvider>
      <div className="sf-app sf-app--nav">
        <a className="sf-skip" href={`#${MAIN_ID}`} onClick={skipToContent}>
          {t("shell.skip")}
        </a>
        <TopBar />
        <main className="sf-main" id={MAIN_ID} tabIndex={-1}>
          <OfflineNotice />
          <UpdateNotice />
          {children}
        </main>
        <BottomNav />
      </div>
    </LiveRegionProvider>
  );
}
